import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Suggest_Interface } from 'src/app/Interface/Suggest_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuggestService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<Suggest_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Suggest").pipe(
      map(data=>{
        return data as Array<Suggest_Interface>
      })
    )
  }

  GetReport(StartSearchDate: String,
    EndSearchDate:String,
    period:number,
    username:String):Observable<Array<Suggest_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Suggest/GetReport?period="+period
    +"&username="+username
    +"&startdate="+StartSearchDate
    +"&enddate="+EndSearchDate).pipe(
      map(data=>{
        return data as Array<Suggest_Interface>
      })
    )
  }

  GetOperation(id:number):Observable<Array<Suggest_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Suggest/GetOperation?id="+id).pipe(
      map(data=>{
        return data as Array<Suggest_Interface>
      })
    )
  }

  uploadFile(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Suggest/Upload", body).pipe(
      map(data=>{

        return data
      })
    )
  }

  SubmitTicket(message: string,
    dsc: string,
    id: number,
    title_id: number,
    order_id: number,
    point: number,
    file: Array<string>): Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id:id,
      title_id:title_id,

    }

    var body={
      model:model,
      message:message,
      dsc:dsc,
      point:point,
      order_id:order_id,
      files:file
    }


      return this.http.post(environment.BaseUrl + "Daro/Suggest/SubmitSuggest",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

}
